module.exports = __webpack_public_path__ + "img/aaron-griffin-sketch-series.c34e627.jpg";